import React from 'react';
import moment from 'moment';
import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, tooltipClick } from '@/components/TableCell';
import styles from './OrderTable.module.scss';

class OrderTable extends React.Component {
    _takeColumns = () => ([
        {
            title: '账号',
            dataIndex: 'accountNickname',
            key: 'accountNickname',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '手机号',
            dataIndex: 'accountTel',
            key: 'accountTel',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '反馈渠道',
            dataIndex: 'ideaBackSystemTypeDesc',
            key: 'ideaBackSystemTypeDesc',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '用户类型',
            dataIndex: 'appType',
            key: 'appType',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '反馈类型',
            dataIndex: 'ideaBackCode',
            key: 'ideaBackCode',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '问题描述',
            dataIndex: 'questionDesc',
            key: 'questionDesc',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '提交时间',
            dataIndex: 'gmtCreate',
            key: 'gmtCreate',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: text => text ? tooltip(moment(text).format('YYYY-MM-DD HH:mm:ss')) : ''
        },
        {
            title: '处理状态',
            dataIndex: 'processState',
            key: 'processState',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'gmtModify',
            key: 'gmtModify',
            width: '15%',
            align: 'center',
            render: (text, item) => (this._renderActionCell(item))
        },
    ]);

    _deal = (record) => {
        const { tableAction } = this.props;
        if (record.appType && record.appType.code == 'SMAORAGE_YOUXUAN') {
            return null;
        }
        if (record.processState == '未处理') {
            return <a onClick={() => tableAction(record, 'deal')}>处理</a>;
        }
        return null;
    }

    // 操作表格
    _renderActionCell = (record) => {
        const { tableAction } = this.props;
        // 播放视频和反馈类型有关
        return (
            <div className={styles.action}>
                {this._deal(record)}
                <a onClick={() => tableAction(record, 'detail')}>查看详情</a>
                {record.videoUrl && <a onClick={() => tableAction(record, 'play')}>播放视频</a>}
            </div>
        );
    }

    _takeDataSource = (dataList) => {
        if (dataList) {
            return dataList;
        } else {
            return [];
        }
    }

    _renderTextCell = (text) => {
        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {text}
            </div>
        );
    };

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey="id"
                    columns={this._takeColumns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

OrderTable.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    paginationChange: PropTypes.func.isRequired, // 分页操作
    tableAction: PropTypes.func.isRequired, // 表格操作
};

export default OrderTable;